<template>
<div class="content">
  <div class="phone">智慧服务热线：400-900-1408</div>
</div>
</template>

<script>
export default {
  name: "contactUs"
}
</script>

<style lang="scss" scoped>
.content{
  .phone{
    font-size: 30px;padding: 30px;text-align: left;
  }
}
</style>
